import React from "react";
import { Link } from "react-router-dom";
import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import { SERVICES } from "@/pages/ServiceDetail";
import { ArrowRight } from "@phosphor-icons/react";

export default function Services() {
  const entries = Object.entries(SERVICES);
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <section className="border-b tf-hairline bg-white">
        <div className="mx-auto max-w-7xl px-6 lg:px-8 py-16 lg:py-20">
          <div className="text-xs font-mono uppercase tracking-widest text-[#D32F2F]">Services</div>
          <h1 className="mt-3 font-[Chivo] text-5xl lg:text-6xl font-black text-[#0A2540] tracking-tight">Every filing scenario, one team.</h1>
          <p className="mt-5 max-w-2xl text-lg text-slate-600">From simple 1040s to consolidated corporate returns and international disclosures — our licensed staff handles the full lifecycle.</p>
        </div>
      </section>
      <section className="mx-auto max-w-7xl px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-2 gap-px bg-slate-200 border tf-hairline">
          {entries.map(([slug, s]) => (
            <Link key={slug} to={`/services/${slug}`} className="bg-white p-8 hover:bg-[#0A2540] hover:text-white group transition-colors" data-testid={`services-list-${slug}`}>
              <div className="text-xs font-mono uppercase tracking-widest text-[#D32F2F] group-hover:text-white/70">{s.pricing}</div>
              <h3 className="mt-3 font-[Chivo] text-2xl font-bold">{s.name}</h3>
              <p className="mt-3 text-sm text-slate-600 group-hover:text-slate-200">{s.tagline}</p>
              <div className="mt-6 inline-flex items-center gap-1 text-sm font-semibold">Learn more <ArrowRight size={14} /></div>
            </Link>
          ))}
        </div>
      </section>
      <Footer />
    </div>
  );
}
